import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/actionOperations')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/actionOperation' })
  },
})
